module.exports = __webpack_public_path__ + "static/img/open-platinum.ec91f7a1.png";